import React from 'react';
import { Link } from 'react-router-dom';
import { AiFillPlusCircle } from 'react-icons/ai';
import './writeIcon.css';
import SvgDefs from './SvgDefs';

export default function WriteIcon() {
  return (
      <>
        <SvgDefs />
        <div className='iconContainer'>
          <Link to={`/share`}>
            <AiFillPlusCircle className='addIcon' style={{ fill: "url(#iconGradient)" }} />
          </Link>
        </div>
      </>
    );
  }
